// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HPg1","footer":"styles_footer__F1WUc","passCodeTooltip":"styles_passCodeTooltip__1nYHL"};